import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { ReaderStatCard, ReaderStatCardItem } from './ReaderStatCard'

interface Props {
  statCards: ReaderStatCardItem[]
}

export const ReaderStatCards = ({ statCards }: Props) => (
  <FlexBox
    className={css`
      width: 100%;
      gap: 8px;
    `}
  >
    {statCards.map((stat, i) => (
      <ReaderStatCard key={i} {...stat} />
    ))}
  </FlexBox>
)
